<template>
    <div>
        <div class="nav-scroller bg-white box-shadow">
            <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                <nav class="nav nav-underline">
                    <router-link class="nav-link" v-bind:to="{name:'devices'}">Devices</router-link>
                    <router-link class="nav-link" v-bind:to="{name:'gateways'}">Gateways</router-link>
                    <router-link class="nav-link" v-bind:to="{name:'device-models'}">Device models</router-link>
                    <a href="https://gw-admin.wbstech.com.au/" target="_blank" class="nav-link">Gateway VPN</a>
                </nav>
            </RequiresGlobalPermissions>
        </div>
        <router-view :key="$route.fullPath" class="container-fluid"></router-view>
    </div>
</template>

<script>
import RequiresGlobalPermissions from "@/components/RequiresGlobalPermissions";

export default {
    components: {
      RequiresGlobalPermissions,
    },
    data () {
      return {
        account: {}
      }
    },
    mounted () {
      this.load()
    },
    methods: {
      load () {
      }
    }
  }
</script>